import {
  chromeStoreUrl,
  chromeWalletExtensions,
  getWalletIcon,
  isWalletInstalled,
  Wallet,
  WalletExtensionNotFoundError
} from '@cardano-foundation/cardano-connect-with-wallet-core';

import { getCustomNaNoId } from '@/utils';

import { WalletBase } from '../WalletBase';
import { ISignInMessage, ISignResult } from '../types';

export class ADAWallet extends WalletBase {
  authType = 'ADA';
  wallets: any[] = [];
  private static supportedWallets: string[] = ['Flint', 'Nami', 'Eternl', 'Yoroi', 'Typhon', 'NuFi', 'Lace'];

  init(): void {
    this.provider = Wallet;
    const wallets = Wallet.getInstalledWalletExtensions();
    this.wallets = wallets;
  }

  static getWalletList(): any[] {
    const wallets = this.supportedWallets.map((name) => {
      const wallet = chromeWalletExtensions[name.toUpperCase() as keyof typeof chromeWalletExtensions];
      return {
        ...wallet,
        name,
        icon: getWalletIcon(name),
        installed: isWalletInstalled(name.toLowerCase())
      };
    });
    return wallets;
  }

  async connectWalletByName(name: string): Promise<string> {
    if (!isWalletInstalled(name.toLowerCase())) {
      const wallet = chromeWalletExtensions[name.toUpperCase() as keyof typeof chromeWalletExtensions];
      window.open(`${chromeStoreUrl}${wallet.name}/${wallet.id}`, '_blank');
      throw new WalletExtensionNotFoundError(name);
    }
    return new Promise((resolve, reject) => {
      this.provider.connect(
        name,
        'mainnet' as any,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        async () => {
          const user = await this.provider.getRewardAddresses();
          console.log(user, 'user');
          this.authType = name;
          if (user) {
            resolve(user);
          }
        },
        (err: any) => {
          reject(err);
        }
      );
    });
  }

  async connect(name: string): Promise<boolean> {
    // let walletName = name;
    // if (!name && this.authType) {
    //   walletName = this.authType;
    // } else {
    //   throw new Error('Wallet name is required');
    // }
    const user = await this.connectWalletByName(name);
    this.address = user[0];
    return true;
  }

  signMessage(message: string): Promise<{ signature: string; key: string }> {
    return new Promise((resolve, reject) => {
      this.provider.signMessage(message, (signature: string, key: string) => {
        if (signature && key) {
          resolve({ signature, key });
        } else {
          reject(new Error('Failed to sign message'));
        }
      });
    });
  }

  // 长度限制，去掉部分字段
  getSignInMessage(): ISignInMessage {
    return {
      statement: 'Welcome to EthSign',
      issuedAt: new Date().toISOString(),
      // uri: window.location.origin,
      nonce: getCustomNaNoId()
    };
  }

  async sign(_message: string): Promise<ISignResult> {
    const message = _message.replace(/\n/g, '');
    // 将message中的空格去掉
    const { signature, key } = await this.signMessage(message);
    this.publicKey = key; //key不是公钥
    return {
      message: message,
      signature: signature
    };
  }
}
